import { remoteLibsConfig } from '@/resources/remote-libs';
import { RemoteLibsService } from '@/services/remote-libs.service';

export const useRemoteLibs = () => {
  const autoDownloadAll = async () => {
    try {
      const service = new RemoteLibsService();
      for (const item of remoteLibsConfig) {
        const { libName, autoDownload } = item;
        if (autoDownload) service.getLibFilename(libName);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    autoDownloadAll
  };
};
